module.exports = __webpack_public_path__ + "861b96381762089d803205a6ea43d37f.MP3";